import { Bar, BarSvgProps } from '@nivo/bar'
import { useEffect, useRef, useState } from 'react'

import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'

const X_AXIS_VISIBLE_MAX = 14
const CHART_STYLE: Partial<BarSvgProps<any>> = {
  margin: {
    top: 0,
    left: 0,
    right: 0,
    bottom: -1,
  },
  colors: ['rgba(198, 211, 230, 1)'],
  role: 'presentation',
  animate: true,
}

const getChartGraphData = (data, dataKey, indexBy) => {
  if (data.length < X_AXIS_VISIBLE_MAX) {
    const gap = X_AXIS_VISIBLE_MAX - data.length
    const blanks = Array(gap)
      .fill(0)
      .map((_, i) => ({
        x: i,
        y: null,
      }))
    const validDatas = data.map((item, i) => {
      return {
        x: gap + i,
        y: Number(item[dataKey]?.toFixed(0)),
      }
    })
    return [...blanks, ...validDatas]
  } else {
    return Array(X_AXIS_VISIBLE_MAX)
      .fill(0)
      .map((_, i) => {
        return {
          x: i,
          y: data[i] ? Number(data[i][dataKey])?.toFixed(0) : 0,
        }
      })
  }
}

const SimpleBarChart = ({ data, graphKey, leftCount, rightCount, marker = 0, options = {} }) => {
  const { t } = useTranslation()
  const chartWrapRef = useRef<HTMLDivElement>(null)
  const [chartWidth, setChartWidth] = useState(0)
  const [chartHeight, setChartHeight] = useState(0)
  useEffect(() => {
    if (chartWrapRef.current) {
      const width = chartWrapRef.current.offsetWidth
      const height = chartWrapRef.current.offsetHeight
      setChartWidth(width)
      setChartHeight(height)
    }
  }, [chartWrapRef])
  const graphData = getChartGraphData(data, graphKey, 'turn')

  if (!graphData) return <></>
  return (
    <div className={styles.highlight.item.box}>
      <p className="flex items-end">
        <span className={styles.highlight.item.left.count}>{leftCount}</span>
        <span className={styles.highlight.item.left.unit}>
          {rightCount && `/${rightCount}`}
          {t(n_caf.highlight.count)}
        </span>
      </p>
      <div className="h-[52px] max-w-[216px] flex-1" ref={chartWrapRef}>
        <Bar
          {...CHART_STYLE}
          data={graphData}
          height={chartHeight}
          width={chartWidth}
          ariaLabel="bar-chart"
          axisLeft={null}
          enableGridX={false}
          enableGridY={false}
          enableLabel={false}
          borderRadius={2}
          padding={0.5}
          indexBy={'x'}
          keys={['y']}
          markers={[
            {
              axis: 'y',
              value: marker,
              lineStyle: {
                stroke: marker ? COLORS.PURPLE500 : 'transparent',
                strokeWidth: 1,
                strokeDasharray: '2 2',
              },
            },
          ]}
          tooltip={() => null}
          {...options}
        />
      </div>
    </div>
  )
}
export default SimpleBarChart

const styles = {
  highlight: {
    item: {
      box: `flex w-full items-end justify-between font-bold`,
      left: {
        count: `mr-[2px] text-[20px] leading-[24px] text-gray-700`,
        unit: `text-[14px] text-gray-300`,
      },
    },
  },
}
